import { Analises } from "./Analises";

export default Analises;